<template>
  <div class="hello">
    <div class="stepbar" v-if="step != 7">
      <div :class="{ step: true, active: step < 7, done: step > 7 }">
        <svg v-if="step > 7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M256,0C114.84,0,0,114.84,0,256S114.84,512,256,512,512,397.16,512,256,397.16,0,256,0ZM389.23,170.2,223.82,367.13a19.71,19.71,0,0,1-14.77,7h-.34a19.67,19.67,0,0,1-14.63-6.52l-70.89-78.77a19.69,19.69,0,1,1,28.65-27c.21.23.42.45.62.68l55.74,61.94L359.08,144.87a19.69,19.69,0,0,1,30.15,25.33Z">
          </path>
        </svg>

        <svg v-if="step <= 6" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <defs></defs>
          <path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path>
          <path d="M494,256C494,124.6,387.4,18,256,18S18,124.6,18,256,124.6,494,256,494,494,387.4,494,256Z"
            style="fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 32px;"></path>
        </svg>
        Analyse
      </div>
      <div :class="{ step: true, active: step > 7 && step<100, done:step==100, last: false }">
        <svg v-if="step < 7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path>
        </svg>
        <svg v-if="step > 7 && step<100" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <defs></defs>
          <path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path>
          <path d="M494,256C494,124.6,387.4,18,256,18S18,124.6,18,256,124.6,494,256,494,494,387.4,494,256Z"
            style="fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 32px;"></path>
        </svg>
        <svg v-if="step == 100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M256,0C114.84,0,0,114.84,0,256S114.84,512,256,512,512,397.16,512,256,397.16,0,256,0ZM389.23,170.2,223.82,367.13a19.71,19.71,0,0,1-14.77,7h-.34a19.67,19.67,0,0,1-14.63-6.52l-70.89-78.77a19.69,19.69,0,1,1,28.65-27c.21.23.42.45.62.68l55.74,61.94L359.08,144.87a19.69,19.69,0,0,1,30.15,25.33Z">
          </path>
        </svg>
        Kontaktdaten
      </div>
      <div :class="{ step: true, active: step == 100, last: true }">
        <svg v-if="step < 100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path>
        </svg>
        <svg v-if="step == 100" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <defs></defs>
          <path d="M419,256A163,163,0,1,0,256,419,163,163,0,0,0,419,256Z"></path>
          <path d="M494,256C494,124.6,387.4,18,256,18S18,124.6,18,256,124.6,494,256,494,494,387.4,494,256Z"
            style="fill: none; stroke: currentColor; stroke-miterlimit: 10; stroke-width: 32px;"></path>
        </svg>

        Angebot
      </div>

    </div>
    <div class="step stepcontent" v-if="step == 0">
      <h2>Wofür ist die Solaranlage bestimmt?</h2>
      <h3>Bitte wählen Sie aus:</h3>

      <div class="selector">
        <div :class="{ choise: true, active: businesstype == item.value }" v-for="(item, index) in businesstypes"
          v-bind:key="index" @click.prevent="businesstype = item.value">
          <div class="selector-container radio-selector"><span class="radio"></span></div>
          <img :src="item.icon" />
          <h3 v-text="item.title"></h3>
        </div>
      </div>

      <div class="nav">
        <button @click="step = 1" :disabled="businesstype == null">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>
    <div class="step stepcontent" v-if="step == 1">
      <h2>Wie hoch ist Ihr Jahresstromverbrauch ca.?</h2>

      <div class="xlrr">
        <div>
          <div class="lblline">
            kWh: <span v-text="formatedverbrauch()"></span>
          </div>
          <range-slider class="slider" min="1000" max="15000" step="100" v-model="verbrauch">
          </range-slider>
        </div>
        <div>
          <img :src="require('../assets/sideimage.png')">
        </div>
      </div>

      <div class="nav">
        <button @click="step = 2" :disabled="businesstype == null">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>

    <div class="step stepcontent" v-if="step == 2">
      <h2>Welche Form hat Ihr Dach?</h2>


      <div class="selector">
        <div :class="{ choise: true, active: rooftype == item.value }" v-for="(item, index) in rooftypes" v-bind:key="index"
          @click.prevent="rooftype = item.value">
          <div class="selector-container radio-selector"><span class="radio"></span></div>
          <img :src="item.icon" />
          <h3 v-text="item.title"></h3>
        </div>
      </div>

      <div class="nav">
        <button @click="step = 3" :disabled="rooftype == null">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>
    <div class="step stepcontent" v-if="step == 3">
      <h2>Wann wurde Ihr Dach gebaut?</h2>


      <div class="selector rowb">
        <div :class="{ choise: true, active: baujahr == item.value }" v-for="(item, index) in baujahre" v-bind:key="index"
          @click.prevent="baujahr = item.value">
          <div class="selector-container radio-selector"><span class="radio"></span></div>
          <img :src="item.icon" />
          <h3 v-text="item.title"></h3>
        </div>
      </div>

      <div class="nav">
        <button @click="step = 4" :disabled="baujahr == null">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>
    <div class="step stepcontent" v-if="step == 4">
      <h2>Wie viel Fläche steht für eine Solaranlage ca. zur Verfügung?</h2>


      <div class="selector rowc">
        <div :class="{ choise: true, active: flaeche == item.value }" v-for="(item, index) in flaechen" v-bind:key="index"
          @click.prevent="flaeche = item.value">
          <div class="selector-container radio-selector"><span class="radio"></span></div>
          <img :src="item.icon" />
          <h3 v-text="item.title"></h3>
        </div>
      </div>

      <div class="nav">
        <button @click="step = 5" :disabled="flaeche == null">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>
    <div class="step stepcontent" v-if="step == 5">
      <h2>Wäre ein Speicher für Sie interessant?</h2>


      <div class="selector rowd">
        <div :class="{ choise: true, active: speicher == item.value }" v-for="(item, index) in speichertypes"
          v-bind:key="index" @click.prevent="speicher = item.value">
          <div class="selector-container radio-selector"><span class="radio"></span></div>
          <img :src="item.icon" />
          <h3 v-text="item.title"></h3>
        </div>
      </div>

      <div class="nav">
        <button @click="step = 6" :disabled="speicher == null">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>
    <div class="step stepcontent" v-if="step == 6">
      <h2>Wo soll die Solaranlage installiert werden?</h2>
      <h3>(Zur Berechnung der Sonneneinstrahlung)</h3>
      <div class="col2layout">
        <div class="field">
          <label :class="{ floated: isfloated('location', 'zip') }">Postleitzahl</label>
          <input type="text" v-model="location.zip" @focus="hover('location', 'zip')" @blur="blur('location', 'zip')" minlength="5" maxlength="5" required pattern="[0-9.]+"
            @input="$forceUpdate()" />
        </div>
        <div class="field">
          <label :class="{ floated: isfloated('location', 'city') }">Ort/Stadt</label>
          <input type="text" v-model="location.city" @focus="hover('location', 'city')" @blur="blur('location', 'city')" minlength="3" required
            @input="$forceUpdate()" />
        </div>
        <div class="field">
          <label :class="{ floated: isfloated('location', 'street') }">Straße</label>
          <input type="text" v-model="location.street" @focus="hover('location', 'street')" minlength="3" required
            @blur="blur('location', 'street')" @input="$forceUpdate()" />
        </div>
        <div class="field">
          <label :class="{ floated: isfloated('location', 'housenumber') }">Hausnummer</label>
          <input type="text" v-model="location.housenumber" @focus="hover('location', 'housenumber')" maxlength="5" minlength="1" required
            @blur="blur('location', 'housenumber')" @input="$forceUpdate()" />
        </div>
      </div>



      <div class="nav">
        <button @click="step = 7; timerx()" :disabled="!locationfilled()">
          <div class="content align-center">
            <div class="label-container"><span class="label">Weiter</span></div>
          </div>
        </button>
      </div>
    </div>

    <div v-if="step == 7" class="step stepcontent loading">
      <h2>Wir suchen passende Angebote für Ihren Standort...</h2>
      <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>

    <div class="step stepcontent" v-if="step == 8">
      <h1>HERZLICHEN GLÜCKWUNSCH!</h1>
      <h2>Wir haben das passende Angebot für Sie erstellt</h2>
      <p><b>Bitte geben Sie Ihre Kontaktdaten an, damit wir Ihr kostenloses Angebot zusenden können.</b></p>
      <div class="col2layout">
        <div class="field">
          <label :class="{ floated: isfloated('contact', 'vorname') }">Vorname</label>
          <input type="text" v-model="contact.vorname" @focus="hover('contact', 'vorname')" minlength="3" required
            @blur="blur('contact', 'vorname')" @input="$forceUpdate()" />
        </div>
        <div class="field">
          <label :class="{ floated: isfloated('contact', 'nachname') }">Nachname</label>
          <input type="text" v-model="contact.nachname" @focus="hover('contact', 'nachname')" minlength="3" required
            @blur="blur('contact', 'nachname')" @input="$forceUpdate()" />
        </div>
        <div class="field fullline withicon">
          <label :class="{ floated: isfloated('contact', 'email') }">E-Mail</label>
          <input type="email" v-model="contact.email" @focus="hover('contact', 'email')" minlength="3" required
            @blur="blur('contact', 'email')" @input="$forceUpdate()" />
          <div class="inpicon">
            <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_15_9)">
<rect width="24" height="24" fill="white"/>
<path d="M3 20V8.5884C3 8.22524 3.19689 7.89062 3.51436 7.71425L11.5144 3.2698C11.8164 3.10201 12.1836 3.10201 12.4856 3.2698L20.4856 7.71425C20.8031 7.89062 21 8.22524 21 8.5884V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20Z" stroke="#000000" stroke-linejoin="round"/>
<path d="M3 8.5L12 13.5L21 8.5" stroke="#000000" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_15_9">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
          </div>
        </div>
        <div class="field fullline withicon">
          <label :class="{ floated: isfloated('contact', 'phone') }">Telefonnummer</label>
          <input type="tel" v-model="contact.phone" @focus="hover('contact', 'phone')" minlength="3" required
            @blur="blur('contact', 'phone')" @input="$forceUpdate()" />
          <div class="inpicon">
            <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 5V9M15 9L19 9M15 9L21 3M18.5 21C9.93959 21 3 14.0604 3 5.5C3 5.11378 3.01413 4.73086 3.04189 4.35173C3.07375 3.91662 3.08968 3.69907 3.2037 3.50103C3.29814 3.33701 3.4655 3.18146 3.63598 3.09925C3.84181 3 4.08188 3 4.56201 3H7.37932C7.78308 3 7.98496 3 8.15802 3.06645C8.31089 3.12515 8.44701 3.22049 8.55442 3.3441C8.67601 3.48403 8.745 3.67376 8.88299 4.05321L10.0491 7.26005C10.2096 7.70153 10.2899 7.92227 10.2763 8.1317C10.2643 8.31637 10.2012 8.49408 10.0942 8.64506C9.97286 8.81628 9.77145 8.93713 9.36863 9.17882L8 10C9.2019 12.6489 11.3501 14.7999 14 16L14.8212 14.6314C15.0629 14.2285 15.1837 14.0271 15.3549 13.9058C15.5059 13.7988 15.6836 13.7357 15.8683 13.7237C16.0777 13.7101 16.2985 13.7904 16.74 13.9509L19.9468 15.117C20.3262 15.255 20.516 15.324 20.6559 15.4456C20.7795 15.553 20.8749 15.6891 20.9335 15.842C21 16.015 21 16.2169 21 16.6207V19.438C21 19.9181 21 20.1582 20.9007 20.364C20.8185 20.5345 20.663 20.7019 20.499 20.7963C20.3009 20.9103 20.0834 20.9262 19.6483 20.9581C19.2691 20.9859 18.8862 21 18.5 21Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </div>
        </div>
      </div>
      <br /><br>
      <div class="dsgvoframe">
        <input type="checkbox" v-model="dsgvo"> Ich stimme der <a href="/datenschutz" target="_blank">Datenschutzerklärung</a> zu.
      </div>
      



      <div class="nav">
        <button @click="sendmail()" :disabled="!contactfilled()">
          <div class="content align-center green">
            <div class="label-container"><span class="label">Jetzt Angebot erhalten</span></div>
          </div>
        </button>
      </div>
    </div>
    <div class="step stepcontent" v-if="step==100">
      <h2><span v-text="contact.vorname"></span> <span v-text="contact.nachname"></span>, vielen Dank für Ihre Angaben!</h2>
      <h3>Um das individuelle Angebot schnellstmöglich zu erstellen, melden wir uns innerhalb von 48 Stunden bei Ihnen! </h3>
    </div>


  </div>
</template>

<script>


import RangeSlider from 'vue-range-slider'
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css'



export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    RangeSlider
  },
  computed: {
    isfloated() {
      return (key, sub) => {
        if (this[key][sub].length > 0) return true;
        return (typeof this[key].hover[sub] != "undefined" && this[key].hover[sub] == 1);
      }
    },
    formatedverbrauch() {
      return () => {
        if (this.verbrauch == 1000) return "<=1.000";
        if (this.verbrauch == 15000) return ">=15.000";
        return this.verbrauch.toLocaleString();
      }
    },
    locationfilled() {
      return () => {
        return (this.location.city.length > 3) && (this.location.street.length > 3) && (this.location.zip.length == 5) && !isNaN(this.location.zip) && (this.location.housenumber.length >= 1) && !this.containsNumbers(this.location.street) && !this.containsNumbers(this.location.city)
      }
    },
    contactfilled() {
      return ()=>{
        return this.dsgvo && (this.contact.vorname.length>3) && (this.contact.nachname.length>3) && (this.contact.phone.length>3) && (this.contact.email.length>5) && (this.contact.email.indexOf("@")>-1) && !this.containsNumbers(this.contact.vorname) && !this.containsNumbers(this.contact.nachname);  
      }
    }
  },
  methods: {
    containsNumbers(str) {
      return /\d/.test(str);
    },
    sendmail() {
      let data = "Verbrauch: "+this.verbrauch+"\r\n";
      data+="Objekttyp:"+this.businesstype+"\r\n";
      data+="Dachtyp:"+this.rooftype+"\r\n";
      data+="Baujahr:"+this.baujahr+"\r\n";
      data+="Speicher:"+this.speicher+"\r\n";
      data+="Fläche:"+this.flaeche+"\r\n";
      data+="\r\n===============\r\n\r\nMontageort:\r\n";
      data+=this.location.street+" "+this.location.housenumber+"\r\n";
      data+=this.location.zip+" "+this.location.city+"\r\n";
      

      data+="\r\n===============\r\n\r\nKontakt:\r\n";
      data+=this.contact.vorname+" "+this.contact.nachname+"\r\n";
      data+="E-MAIL:"+this.contact.email+"\r\nTelefon: "+this.contact.phone+"\r\n";
      this.axios.post("/?sendrequest=1", {content:data, location:this.location, contact:this.contact, verbrauch:this.verbrauch, flaeche:this.flaeche, businesstype:this.businesstype,baujahr:this.baujahr, speicher:this.speicher }).then(()=>{
        this.step = 100;
      }, function(error){
        this.step = 100;
        console.log(error);
      });
      
    },
    timerx() {
      setTimeout(() => {
        this.step = 8;
      }, 4500);
    },
    hover(key, sub) {
      this[key].hover[sub] = 1;
      this.$forceUpdate();
    },
    blur(key, sub) {
      this[key].hover[sub] = 0;
      this.$forceUpdate();
    }
  },
  data() {
    return {
      dsgvo:false,
      verbrauch: 4000,
      businesstype: null,
      rooftype: null,
      baujahr: null,
      flaeche: null,
      speicher: null,
      contact:{
        hover:{},
        vorname:"",
        nachname:"",
        email:"",
        phone:""
      },
      location: {
        zip: "",
        city: "",
        street: "",
        housenumber: "",
        hover: {}
      },
      speichertypes: [
        {
          title: "Ja",
          value: "ja",
          icon: require("../assets/box1.png")
        },
        {
          title: "Nein",
          value: "nein",
          icon: require("../assets/box2.png")
        },
        {
          title: "Unentschlossen",
          value: "unentschlossen",
          icon: require("../assets/sonstiges.png")
        },
      ],
      flaechen: [
        {
          title: "Bis 20m²",
          value: "bis20",
          icon: require("../assets/house1.png")
        },
        {
          title: "20-50m²",
          value: "20_50",
          icon: require("../assets/house2.png")
        },
        {
          title: "50-100m²",
          value: "50_100",
          icon: require("../assets/house4.png")
        },
        {
          title: "Über 100m²",
          value: "ueber100",
          icon: require("../assets/house3.png")
        },
      ],
      baujahre: [
        {
          title: "Erst in Planung",
          value: "planung",
          icon: require("../assets/planung.png")
        },
        {
          title: "Gerade erst gebaut",
          value: "neubau",
          icon: require("../assets/neubau.png")
        },
        {
          title: "Vor 1985",
          value: "before85",
          icon: require("../assets/before85.png")
        },
        {
          title: "Nach 1985",
          value: "after85",
          icon: require("../assets/after85.png")
        },
      ],
      rooftypes: [
        {
          title: "Fachdach",
          value: "Fachdach",
          icon: require("../assets/flachfach.png")
        },
        {
          title: "Pultdach",
          value: "pultdach",
          icon: require("../assets/pultdach.png")
        },
        {
          title: "Satteldach",
          value: "satteldach",
          icon: require("../assets/satteldach.png")
        },
        {
          title: "Zeltdach",
          value: "zeltdach",
          icon: require("../assets/zeltdach.png")
        },
        {
          title: "Sonstiges Dach",
          value: "sonstiges",
          icon: require("../assets/sonstiges.png")
        },

      ],
      step: 0,
      businesstypes: [
        {
          title: "Privat",
          value: "private",
          icon: require("../assets/private.png")
        },
        {
          title: "Gewerbe",
          value: "business",
          icon: require("../assets/business.png")
        },
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  width: 100%;
}

.stepcontent {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.stepcontent .nav {
  display: flex;
  justify-content: center;

}

.stepcontent .nav button {
  margin-top: 50px;
  width: 200px;

}

.stepcontent .nav button:disabled {
  background: #888;
}

.stepcontent .nav button:not(:disabled) {
  cursor: pointer;
}

.selector {
  justify-content: center;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.selector.rowb>div {
  max-width: calc(50% - 30px);
}

.selector.rowc>div {
  max-width: calc(25% - 30px);
}

.selector.rowd>div {
  max-width: calc(33% - 30px);
}

.selector img {
  max-width: 80%;
}

.selector>div {
  max-width: calc(33% - 30px);
  padding-top: 15px;
  border-radius: 15px;
  border: 1px solid #AAA;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.selector>div.active h3 {
  background: #000061;
  color: white;
}

.selector>div.active .radio {
  background: #000061;
  border-color: #fff;
  -webkit-box-shadow: 0 0 0 1px #000061;
  box-shadow: 0 0 0 1px #000061;
}

.selector>div h3 {
  padding-top: 10px;
  padding-bottom: 10px;
  background: #FFD903;
  margin-top: 0px;
  margin-bottom: 0px;

}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.stepbar {
  display: grid;
  max-width: 768px;
  margin-left: auto;
  margin-right: auto;
  grid-template-columns: 1fr 1fr 1fr;
}

.stepbar .step {
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  gap: 20px;
  flex-direction: column;
  ;
}

.stepbar .step svg {
  width: 36px;
  z-index: 1;
}

.stepbar .step+.step:before {
  border-bottom: 2px solid #888;
  width: calc(50% - 18px);
  position: absolute;
  content: '';
  left: 0px;
  top: 18px;
}

.stepbar .step:not(.last):after {
  border-bottom: 2px solid #888;
  width: calc(50% - 18px);
  position: absolute;
  content: '';
  right: 0px;
  top: 18px;
}

.stepbar .step.done:not(.last):after {
  border-bottom-color: #FFD903 !important
}

.stepbar .step.done:not(.last)+.step:before {
  border-bottom-color: #FFD903 !important
}

.selector-container {
  margin: 0;
  position: absolute;
  z-index: 1;
  top: 5px;
  right: 5px;
  bottom: auto;
  left: auto;
  display: block;
  -webkit-transform: none;
  transform: none;
}

.radio {
  cursor: pointer;
  -webkit-box-shadow: 0 0 0 1px #e1e1e4;
  box-shadow: 0 0 0 1px #e1e1e4;
  display: inline-block;
  position: relative;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  -webkit-transition: border box-shadow .1s;
  transition: border box-shadow .1s;
  border-radius: 20px;
  height: 20px;
  width: 20px;
  background: transparent;
  border: 2.5px solid transparent;
}

.option-content .radio {
  -webkit-transition: all;
  transition: all;
  -webkit-transition-duration: .1s;
  transition-duration: .1s;
  -webkit-box-shadow: 0 0 0 1px #e1e1e4;
  box-shadow: 0 0 0 1px #e1e1e4;
  border-width: 2.5px;
  height: 20px;
  width: 20px;
  background: #fff;
  border-color: #fff;
}

.radio {
  background: #fff;
  border-color: #e1e1e4;
  -webkit-box-shadow: 0 0 0 1px #eaeaeb;
  box-shadow: 0 0 0 1px #eaeaeb;
  height: 20px;
  width: 20px;
}

button {
  width: 100%;
  -webkit-transition-property: all;
  transition-property: all;
  text-align: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  white-space: nowrap;
  outline: none;
}

button {
  padding: 0.875em 1em;
  -webkit-transition-duration: .2s;
  transition-duration: .2s;
  border-radius: 7.5px;
  background: #000061;
  -webkit-transform: none;
  transform: none;
  -webkit-box-shadow: unset;
  box-shadow: unset;
  border: 1px solid transparent;
  font-size: 1rem;
}

.align-center,
.center {
  text-align: center;
}

button .content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-transition-duration: .2s;
  transition-duration: .2s;
}

button.generic-button .content.align-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

button .label-container {
  -webkit-box-align: inherit;
  -ms-flex-align: inherit;
  align-items: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  max-width: 100%;
  overflow-x: auto;
  overflow-x: clip;
}

button .label {
  max-width: 100%;
  -webkit-transition-property: all;
  transition-property: all;
  overflow-x: auto;
  overflow-x: clip;
  text-overflow: ellipsis;
}

button .label {
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
}

.content.align-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

>>>span.range-slider-fill {
  background-color: #000061 !important;
}

.xlrr {
  display: grid;
  grid-template-columns: 3fr 1fr;
  margin-top: 40px;
}

.xlrr img {
  max-width: 50%;
}

.lblline {
  margin-bottom: 20px;
  text-align: left;
}

.lblline span {
  background: #EEE;
  padding: 15px;
}

.col2layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
}

.col2layout>div {
  position: relative;
}

.col2layout>div.fullline {
  grid-column-start: 1;
  grid-column-end: span 2;
}
.col2layout label {
  position: absolute;
  pointer-events: none;
  top: calc(50% - 10px);
  left: 0.8em;
  transition: all 0.2s linear;
  font-size: 16px;
}


.col2layout input {
  box-sizing: border-box;
  padding: 1.8em 0.8em 0.5em;
  font-size: .9em;
  font-weight: 600;
  border: none;
  outline: none;
  background: none;
  width: 100%;
  -webkit-appearance: none;
  -webkit-transition-property: all;
  transition-property: all;
  font-size: 1.125rem;
  color: #0a0908;
  font-weight: 400;
  font-family: Arial;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 5px;

  background: rgba(0, 0, 0, .03);
  -webkit-transition-duration: .1s;
  transition-duration: .1s;
  border: 0 solid rgba(0, 0, 0, .03);

}

.col2layout label.floated {
  top: 5px;
  font-size: 14px;
}
.inpicon svg {
    max-width: 100%;
    height: auto;
}

.inpicon {
    width: 30px;
    position: absolute;
    top: calc(50% - 15px);
}
.withicon input {
  padding-left: 55px!important;
}
.withicon label {
  left: 55px!important;
}
.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #000061;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>

